import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=4abe6d71&"
import script from "./demo.vue?vue&type=script&lang=js&"
export * from "./demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.4.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\other\\tsTest\\vue-gecode\\node_modules\\_vue-hot-reload-api@2.3.0@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4abe6d71', component.options)
    } else {
      api.reload('4abe6d71', component.options)
    }
    module.hot.accept("./demo.vue?vue&type=template&id=4abe6d71&", function () {
      api.rerender('4abe6d71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "demo/demo.vue"
export default component.exports